export const CANDIDATE_FILTER_CONSTANTS = {
  LABELS: {
    FILTER: 'Filter',
    NAME: 'Name',
    EXPERIENCE: 'Experience*',
    POSITION: 'Position',
    VENDOR: 'Vendor',
    LOCATION: 'Location',
    AVAILABLE_BY: 'Available By',
    DATE_APPLIED: 'Date Applied',
    HIRING_MANAGER: 'Hiring Manager',
    STATUS: 'Status',
    RESET: 'Reset',
    APPLY: 'Apply',
    SAVE: 'Save'
  },
  
  BUTTON_TYPES: {
    PRIMARY: 'primary',
    SECONDARY: 'Secondary'
  },
  
  BUTTON_SIZES: {
    MEDIUM: 'Medium'
  },
  
  ICONS: {
    FILTER_LIST: 'filter_list'
  },
  
  FORM_FIELD_IDS: {
    SINGLE_SELECT: 'single_select'
  },
  
  ERROR_MESSAGES: {
    SAMPLE_ERROR: 'Sample error text'
  },
  
  CSS_CLASSES: {
    PICKER_DATE: 'pickerDate',
    MDC_DIALOG_BUTTON: 'mdc-dialog__button',
    RAISE_REQUEST: 'raise-request',
    FILTER_CONTAINER: 'filter-container'
  },
  
  FORM_CONTROLS: {
    SELECTED_NAME: 'selectedName',
    SELECTED_EXPERIENCE: 'selectedExperience',
    SELECTED_LOCATION: 'selectedLocation',
    SELECTED_STATUS: 'selectedStatus',
    SELECTED_RECEIVED_ON: 'selectedReceivedOn',
    SELECTED_AVAILABLE_BY: 'selectedAvailableBy',
    SELECTED_DATE_APPLIED: 'selectedDateApplied',
    SELECTED_HIRING_MANAGER: 'selectedHiringManager',
    SELECTED_POSITION: 'selectedPosition',
    SELECTED_VENDOR: 'selectedVendor'
  },
  
  DROPDOWN_CONFIG: {
    PRE_SELECTED_LABEL: 'label',
    PRE_SELECTED_VALUE: 'value'
  },
  
  TIMING: {
    FILTER_LOAD_DELAY: 100,
    FORM_RESET_DELAY: 50,
    FILTER_RESTORE_DELAY: 500
  }
} as const;
